import createPortal from '@sift/skipper/helpers/createPortal';

export default createPortal('Toolbar');
